<web-design-system-modal [headline]="'contract-confirmation.dialog.headline' | transloco" (dismiss)="close()">
  <p [innerHTML]="'contract-confirmation.dialog.body' | transloco"></p>
  @if (facade.contractConfirmations$ | async; as contracts) {
    @for (contract of contracts; track $index) {
      <div class="row" data-zid="contract-confirmation">
        @if (contract.longDescription) {
          <div class="col-12 mb-3">
            {{ contract.longDescription }}
          </div>
        }
        <div class="col-12 col-md-8">
          {{ contract.description }}
        </div>
        <div class="col-12 col-md-4 mt-2 mt-md-0 text-left text-md-right">
          <a [href]="contract.assetUrl" target="_blank" rel="noopener noreferrer" class="link-secondary text-default">{{
            'contract-confirmation.dialog.doc-link' | transloco
          }}</a>
        </div>
      </div>
      <hr />
    }
  }
  @if (facade.error$ | async; as error) {
    <p class="text-color-error">
      {{ error.message }}
    </p>
  }
  <div class="d-flex align-items-center justify-content-between mt-4">
    <a class="link-secondary text-uppercase cursor-pointer" (click)="close()" data-zid="contract-confirmation-close">
      {{ 'contract-confirmation.dialog.close' | transloco }}
    </a>
    <web-design-system-button (click)="accept()" data-zid="contract-confirmation-accept" [disabled]="facade.loading$ | async">
      @if (facade.loading$ | async) {
        {{ 'contract-confirmation.dialog.loading' | transloco }}
      } @else {
        {{ 'contract-confirmation.dialog.accept' | transloco }}
      }
    </web-design-system-button>
  </div>
</web-design-system-modal>
